import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookIcon, ClockIcon, WindIcon, SnowflakeIcon, HeadphonesIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookIcon className="w-6 h-6 text-gold-500" data-id="element-320" />,
    title: 'La Guía Principal "Protocolo de Sueño Profundo 50+"',
    desc: 'El paso a paso sin rellenos.'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-gold-500" data-id="element-321" />,
    title: 'La Rutina 3-2-1',
    desc: 'El sistema exacto para blindar tu noche contra el cortisol.'
  }, {
    icon: <WindIcon className="w-6 h-6 text-gold-500" data-id="element-322" />,
    title: 'La Técnica de Respiración Anestésica 4-7-8',
    desc: 'Cómo apagar tu cerebro en 120 segundos.'
  }, {
    icon: <SnowflakeIcon className="w-6 h-6 text-gold-500" data-id="element-323" />,
    title: 'El Manual de la "Cueva de Hielo"',
    desc: 'Cómo configurar tu habitación para que tu cuerpo no pueda evitar dormir.'
  }, {
    icon: <HeadphonesIcon className="w-6 h-6 text-gold-500" data-id="element-324" />,
    title: 'Audio Guía de Inducción',
    desc: 'Una sesión de relajación progresiva diseñada para voces maduras.'
  }];
  return <section className="py-24 bg-navy-800 border-t border-navy-700" data-id="element-325">
      <div className="max-w-4xl mx-auto px-6" data-id="element-326">
        <FadeIn data-id="element-327">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16" data-id="element-328">
            Lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-329">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-330">
              <div className="flex items-start gap-6 p-6 bg-navy-900 border border-navy-700 rounded-sm hover:border-gold-500/30 transition-colors" data-id="element-331">
                <div className="flex-shrink-0 mt-1" data-id="element-332">{item.icon}</div>
                <div data-id="element-333">
                  <h3 className="text-xl font-serif text-cream mb-2" data-id="element-334">
                    {item.title}
                  </h3>
                  <p className="text-cream-muted" data-id="element-335">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}